module.exports = __webpack_public_path__ + "static/grung_red_cahbulos-60c19f1c014fac752256478b06db8329.jpg";